import { render } from "./FittingDetails.vue?vue&type=template&id=4b2db16c"
import script from "./FittingDetails.vue?vue&type=script&lang=js"
export * from "./FittingDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__